import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { ProgressSteps } from 'shared/ui/ProgressSteps'
import { Alert, Box, Typography } from 'shared/ui'
import {
  getFirstBlockItems,
  getSecondBlockItems,
  getThirdBlockItems,
  QuestionSectionItems,
} from 'entities/Compliance/ui/Questionnaire'
import type { QuestionnaireOrSelectNumberModalStore } from 'entities/Phone/ui/QuestionnaireOrSelectNumberModal'
import { StepSelectNumber } from './StepSelectNumber/StepSelectNumber'
import styles from './styles.module.scss'

type IGetNumberPFTModalContentProps = {
  store: QuestionnaireOrSelectNumberModalStore
}

export const QuestionnaireOrSelectNumberModalContent: FC<IGetNumberPFTModalContentProps> = observer(
  ({ store }) => {
    const questionnaireStepsStore = store.questionnaireStepsStore
    const UKsteps = ['Complete UK compliance', 'Buy a UK number', 'Start texting and calling']

    return (
      <div className={styles.wrapContent}>
        <ProgressSteps title={store.titleStep} total={store.maxStep} step={store.step} />

        {Boolean(store.descriptionStep) && (
          <Typography
            tag={'div'}
            variant={'body-md-regular'}
            ariaLabel={'questionnaireOrSelectNumberModalContent_description'}
            className={styles.description}
          >
            {store.descriptionStep}
          </Typography>
        )}

        <div className={styles.content}>
          {store.step === 1 && (
            <QuestionSectionItems
              items={getFirstBlockItems(
                questionnaireStepsStore.targetCountry,
                questionnaireStepsStore.handleSetTargetCountry
              )}
            />
          )}
          {store.step === 2 && (
            <QuestionSectionItems
              items={getSecondBlockItems(
                questionnaireStepsStore.isTaxId,
                questionnaireStepsStore.handleSetIsTaxId
              )}
            />
          )}
          {store.step === 3 && (
            <QuestionSectionItems
              items={getThirdBlockItems(
                questionnaireStepsStore.numberType,
                questionnaireStepsStore.setNumberType
              )}
            />
          )}
          {questionnaireStepsStore.isShowTaxIdBanner && store.step === 3 && (
            <Alert
              className={styles.alert}
              item={{
                type: 'warning',
                title: 'Based on your responses:',
                desc: (
                  <div className={styles.alertInfo}>
                    <Typography
                      ariaLabel='QuestionsPage_alertInfo'
                      variant='body-md-regular'
                      color='var(--yellow-100)'
                    >
                      • ❌ Can’t send messages
                    </Typography>
                    <Typography
                      ariaLabel='QuestionsPage_alertInfo'
                      variant='body-md-regular'
                      color='var(--yellow-100)'
                    >
                      • ✅ Can make calls
                    </Typography>
                  </div>
                ),
              }}
              rightActions={[
                {
                  variant: 'link',
                  type: 'primary',
                  text: 'Get a business Tax ID',
                  link: questionnaireStepsStore.businessTaxIDLink,
                },
              ]}
            />
          )}
          {store.step === 4 && !store.isGBCountry && <StepSelectNumber store={store} />}
          {store.step === 4 && store.isGBCountry && (
            <Box display={'flex'} flexDirection={'column'} gap={'4px'}>
              {UKsteps.map((step, idx) => (
                <div key={step} className={styles.step}>
                  <div className={styles.step__number}>
                    <Typography
                      variant={'body-md-regular'}
                      ariaLabel={'ukComplianceModalCase1'}
                      color={'var(--content-primary-primary)'}
                    >
                      {idx + 1}
                    </Typography>
                  </div>
                  <Typography
                    variant={'body-md-regular'}
                    ariaLabel={'ukComplianceModalCase1'}
                    color={'var(--content-primary-primary)'}
                  >
                    {step}
                  </Typography>
                </div>
              ))}
            </Box>
          )}
        </div>
      </div>
    )
  }
)
